import { render, staticRenderFns } from "./CopyGraderuleTerm.vue?vue&type=template&id=747dc207"
import script from "./CopyGraderuleTerm.vue?vue&type=script&lang=js"
export * from "./CopyGraderuleTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports